import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class GroupMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }

  getList(data?: any) {
    return this.http.post(Path.GROUP.GET_LIST, data);
  }
  
  insert(data?: any) {
    return this.http.post(Path.GROUP.INSERT, data);
  }

  getWebUsers(data?: any) {
    return this.http.post(Path.GROUP.GET_GRP_WEB_USER, data);
  }

  getRecipients(data?: any) {
    return this.http.post(Path.GROUP.GET_GRP_RECIPIENT, data);
  }

  upsertRecipient(data?: any) {
    return this.http.post(Path.GROUP.UPSERT_RECIPIENT_GROUP_MAPPING, data);
  }

  upsertUser(data?: any) {
    return this.http.post(Path.GROUP.UPSERT_USER_GROUP_MAPPING, data);
  }

  genericMaintenanceDownload(data?: any, mode?) {
    if(mode == 'master') {
      return this.http.post(Path.DOWNLOAD.DOWNLOAD_GROUP_MAINTENACE_MASTER, data);
    }
    else if(mode == 'mapping') {
      return this.http.post(Path.DOWNLOAD.DOWNLOAD_GROUP_MAINTENACE_MAPPING, data);
    }
  }

  getIslandGroup(data?: any) {
    return this.http.post(Path.GROUP.GET_ISLAND_GROUP, data);
  }

  getDistrict(data?: any) {
    return this.http.post(Path.GROUP.GET_DISTRICT, data);
  }
  
  getGroupType(data?: any) {
    return this.http.post(Path.GROUP.GET_GROUP_TYPE, data);
  }
}
